import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTotalDistanceCardFeet = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 123.357,
	height: 119.395,
	viewBox: "0 0 123.357 119.395",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-268.821 -958.803)",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(277.821 1066.198) rotate(-90)",
			children: [/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0, 1, -1, 0, 107.4, -9)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M27.64,101.3c20.025-2.345,9.087-30.832,9.087-45.635,0-9.312,5.182-15.8,5.182-28.553,0-12.178-5.62-26.221-17.135-27.056C8.868-1.1,0,16.48,0,33.672c0,10.388,7.048,27.691,8.633,34.77C10.863,78.391,12.048,103.126,27.64,101.3Z",
					transform: "translate(9 6)",
					fill: "#28666c"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				transform: "translate(20.667 20.036) rotate(90)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M.4,7.777A9.758,9.758,0,0,0,4.511,4.188,19.656,19.656,0,0,0,6.346,0,6.492,6.492,0,0,0,.172,7.973.868.868,0,0,1,.4,7.777Z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M8.582,2.061c-1.447,1.961-2.975,3.2-5.3,3.272A7.83,7.83,0,0,1,0,4.749,6.481,6.481,0,0,0,5.051,7.164a6.5,6.5,0,0,0,6.5-6.5A6.544,6.544,0,0,0,11.51,0C11.285-.006,10.061.056,8.582,2.061Z",
						transform: "translate(1.445 5.825)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M3.783,5.69C7.622,5.572,8.664,2.575,10.059,1.5A3.927,3.927,0,0,1,12.382.573c-.033-.191-.07-.38-.119-.564a5.1,5.1,0,0,0-3.1.762C7.691,1.836,7.152,2.865,4.983,3.828A8.471,8.471,0,0,1,0,4.207,6.494,6.494,0,0,0,.405,5,8.121,8.121,0,0,0,3.783,5.69Z",
						transform: "translate(0.516 4.825)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M.011,8.075c.336.67,2.651-.062,3.645-.679,1.408-.874,2.856-2.8,4.522-3.251a7.09,7.09,0,0,1,2-.248A6.5,6.5,0,0,0,4.652,0,20.252,20.252,0,0,1,3.128,4.121C1.79,6.9-.164,7.727.011,8.075Z",
						transform: "translate(2.279 0.012)",
						fill: "#fff"
					})
				]
			})]
		}), /* @__PURE__ */ _jsxs("g", {
			transform: "translate(341.271 1066.198) rotate(-90)",
			children: [/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0, 1, -1, 0, 107.4, -72.45)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M14.267,101.3C-5.758,98.953,5.18,70.466,5.18,55.664,5.18,46.351,0,39.867,0,27.11,0,14.932,5.62.889,17.133.054,33.038-1.1,41.908,16.48,41.908,33.672c0,10.388-7.05,27.691-8.635,34.77C31.043,78.391,29.858,103.126,14.267,101.3Z",
					transform: "translate(72.45 6)",
					fill: "#28666c"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				transform: "translate(20.667 9.043) rotate(90)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M.4,7.777A9.758,9.758,0,0,0,4.511,4.188,19.656,19.656,0,0,0,6.346,0,6.492,6.492,0,0,0,.172,7.973.868.868,0,0,1,.4,7.777Z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M8.582,2.061c-1.447,1.961-2.975,3.2-5.3,3.272A7.83,7.83,0,0,1,0,4.749,6.481,6.481,0,0,0,5.051,7.164a6.5,6.5,0,0,0,6.5-6.5A6.544,6.544,0,0,0,11.51,0C11.285-.006,10.061.056,8.582,2.061Z",
						transform: "translate(1.445 5.825)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M3.783,5.69C7.622,5.572,8.664,2.575,10.059,1.5A3.927,3.927,0,0,1,12.382.573c-.033-.191-.07-.38-.119-.564a5.1,5.1,0,0,0-3.1.762C7.691,1.836,7.152,2.865,4.983,3.828A8.471,8.471,0,0,1,0,4.207,6.494,6.494,0,0,0,.405,5,8.121,8.121,0,0,0,3.783,5.69Z",
						transform: "translate(0.516 4.825)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M.011,8.075c.336.67,2.651-.062,3.645-.679,1.408-.874,2.856-2.8,4.522-3.251a7.09,7.09,0,0,1,2-.248A6.5,6.5,0,0,0,4.652,0,20.252,20.252,0,0,1,3.128,4.121C1.79,6.9-.164,7.727.011,8.075Z",
						transform: "translate(2.279 0.012)",
						fill: "#fff"
					})
				]
			})]
		})]
	})]
});
const ForwardRef = forwardRef(SvgTotalDistanceCardFeet);
export { ForwardRef as ReactComponent };
